import { useMemo } from 'react'
import activities from '../../../../api/activities/hooks'
import contacts from '../../../../api/contacts/hooks'
import properties from '../../../../api/properties/hooks'
import { PropertyCriteria } from '../../../../api/properties/types'
import { ACTIVITY_TYPE } from '../../../../common/constants'
import { handleResponse } from './utils'

export const useConnectedProperties = (contactId?: number, hasBeenVisible = true) => {
    const enabled = !!contactId && hasBeenVisible

    const propertiesParams = { noLimit: 1, criteria: { owner: contactId } as Partial<PropertyCriteria> }
    const activitiesParams = {
        noLimit: 1,
        criteria: { contact: contactId, activityType: [ACTIVITY_TYPE.SIGHTSEEING.toString(), ACTIVITY_TYPE.OFFER.toString()] },
    }

    const { data: propertyTransactionsData } = contacts.GetContactPropertyTransactions.useQuery(Number(contactId), { enabled })
    const { data: propertiesData } = properties.GetProperties.useQuery(propertiesParams, { enabled })
    const { data: activitiesData } = activities.GetActivities.useQuery(activitiesParams, { enabled })

    const filterData = useMemo(() => {
        if (!propertyTransactionsData || !propertiesData || !activitiesData) return undefined

        return handleResponse({
            contactBuyer: propertyTransactionsData.items || [],
            contactSeller: propertiesData.items || [],
            contactSelectedActivities: activitiesData.items || [],
        })
    }, [propertyTransactionsData, propertiesData, activitiesData])

    return { filterData, isLoading: !filterData }
}
